module.exports = "<footer id=\"app-footer\">\n  <span>Copyright © Sealab - </span>\n  <span> Versión: {{ version }}</span>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/footer/footer.component.html
// module id = ./src/app/common/footer/footer.component.html
// module chunks = main